// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"474":"fe69a73d","3505":"7aeec5c9","6294":"0af98a8b"}[chunkId] || chunkId) + "." + {"474":"7ea4081b83296983","3367":"4c93c72ad6a86d44","3505":"24ea3de7534a0998","5356":"aa440d00b93d1884","6294":"407586a7e6e1f198","6860":"1f9771e4e27ecdc9","7205":"7072e1afc00872fb"}[chunkId] + ".js";
};